import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import BookingsTabs from './bookings-tabs'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: '28px 36px 0',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 8px 0',
    },
  },
}))

const SchedulePage = ({ onboardingSchedule, onMetadataChange }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <BookingsTabs
            onboardingSchedule={onboardingSchedule}
            onMetadataChange={onMetadataChange}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default SchedulePage
